// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".premium-header[data-v-4654e802]{display:flex;flex-direction:column}@media(min-width:768px){.premium-header[data-v-4654e802]{flex-direction:row;align-items:center}}.headline[data-v-4654e802]{font-weight:900;font-size:28px;line-height:32px}.headline-divider[data-v-4654e802]{align-self:normal}.subline[data-v-4654e802]{font-size:16px}", ""]);
// Exports
module.exports = exports;
